document.addEventListener('DOMContentLoaded', function () {
    var blogTeardownContainer = document.querySelector('.blog_teardown');

    if (blogTeardownContainer) {
        var imgContainer = blogTeardownContainer.querySelector('.blog_teardown--fullscreen-img');
        var fullScreenContainer = document.getElementById('BlogTeardownFullScreenContainer');

        imgContainer.addEventListener('click', function () {
            if (window.innerWidth >= 768) {
                var imgSource = imgContainer.querySelector('img').src;

                fullScreenContainer.innerHTML = '<img src="' + imgSource + '" alt="Full Screen Image">';

                fullScreenContainer.style.display = 'flex';
            }
        });

        fullScreenContainer.addEventListener('click', function () {
            fullScreenContainer.style.display = 'none';
        });
    }
});